module.exports = __webpack_public_path__ + "img/image-app-mining.24c7ad47.jpg";